'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('prop-types');
require('styled-components');
require('lodash/get');
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
require('lodash/camelCase');
require('lodash/upperFirst');
var icon = require('./icon.js');
var merge = _interopDefault(require('lodash/merge'));
var styled$1 = require('./tooltip/styled.js');
var _const = require('./const-7e9ce2ed.js');

var Tooltip = function (_React$Component) {
  _babelHelpers.inherits(Tooltip, _React$Component);

  function Tooltip(props) {
    _babelHelpers.classCallCheck(this, Tooltip);

    var _this = _babelHelpers.possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.state = {
      displayTooltip: false
    };
    _this.hideTooltip = _this.hideTooltip.bind(_this);
    _this.showTooltip = _this.showTooltip.bind(_this);
    return _this;
  }

  _babelHelpers.createClass(Tooltip, [{
    key: "hideTooltip",
    value: function hideTooltip(e) {
      e.stopPropagation();
      this.setState({ displayTooltip: false });
    }
  }, {
    key: "showTooltip",
    value: function showTooltip(e) {
      e.stopPropagation();
      this.setState({ displayTooltip: true });
    }
  }, {
    key: "getPosition",
    value: function getPosition(position) {
      switch (position) {
        case "TOP":
        case "BOTTOM":
        case "RIGHT":
        case "LEFT":
          return _const.TOOL_TIPS_POSITIONS[position];
        case "CUSTOM":
          {
            var positionCustom = this.props.positionCustom;

            return positionCustom;
          }
        default:
          return _const.TOOL_TIPS_POSITIONS.RIGHT;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var displayTooltip = this.state.displayTooltip;
      var _props = this.props,
          bubbleWidth = _props.bubbleWidth,
          color = _props.color,
          iconName = _props.iconName,
          iconMargin = _props.iconMargin,
          children = _props.children,
          position = _props.position,
          title = _props.title,
          titleSize = _props.titleSize,
          mTitleSize = _props.mTitleSize,
          weightTitle = _props.weightTitle,
          iconMarginMoblie = _props.iconMarginMoblie,
          className = _props.className,
          marginBox = _props.marginBox,
          paddingBox = _props.paddingBox,
          colorTitle = _props.colorTitle,
          iconSize = _props.iconSize,
          disableMobile = _props.disableMobile,
          mobileShowWidth = _props.mobileShowWidth,
          mobileModalPosition = _props.mobileModalPosition;

      var postionToolTip = this.getPosition(position);
      var modalPosition = merge({
        top: "50px",
        left: "0px",
        right: "0px",
        bottom: "0px"
      }, mobileModalPosition);
      var mobileTooltip = disableMobile ? null : this.showTooltip;
      return React__default.createElement(
        styled$1.TooltipContainer,
        {
          className: "tooltip-box " + className,
          marginBox: marginBox,
          paddingBox: paddingBox },
        React__default.createElement(
          styled$1.ToolTipTitle,
          {
            color: colorTitle,
            weightTitle: weightTitle,
            id: "tooltipBox",
            titleSize: titleSize,
            mTitleSize: mTitleSize,
            onClick: mobileTooltip },
          title,
          React__default.createElement(
            styled$1.TooltipIcon,
            {
              className: "fas " + iconName,
              color: color,
              iconSize: iconSize,
              iconMargin: iconMargin },
            React__default.createElement(
              styled$1.TooltipBubble,
              _babelHelpers._extends({
                className: "tooltiptext",
                width: bubbleWidth,
                mobileShowWidth: mobileShowWidth
              }, postionToolTip),
              children
            )
          )
        ),
        React__default.createElement(styled$1.TooltipIconMobile, {
          iconSize: iconSize,
          className: "fas " + iconName,
          onClick: mobileTooltip,
          color: color,
          iconMarginMoblie: iconMarginMoblie
        }),
        displayTooltip && React__default.createElement(styled$1.TooltipOverlay, {
          onClick: this.hideTooltip,
          displayTooltip: displayTooltip
        }),
        displayTooltip && React__default.createElement(
          styled$1.TooltipMobile,
          {
            position: modalPosition,
            className: "tooltip-mobile-container"
            // To stop event bubbling on clicking inside TooltipMobile modal when using under the Component that also have onClick
            , onClick: function onClick(e) {
              return e.stopPropagation();
            } },
          React__default.createElement(
            styled$1.CloseIcon,
            { onClick: this.hideTooltip },
            React__default.createElement(icon.Icon, { name: "close", size: "sm" })
          ),
          React__default.createElement(
            styled$1.TooltipMobileDetail,
            { className: "tooltip-mobile" },
            children
          )
        )
      );
    }
  }]);
  return Tooltip;
}(React__default.Component);

Tooltip.defaultProps = {
  position: "RIGHT",
  title: "ToolTip",
  colorTitle: "black",
  iconName: "fa-question-circle",
  color: "#3b99fc",
  bubbleWidth: "350px",
  iconMargin: "5px",
  iconMarginMoblie: "-5px",
  weightTitle: "500",
  className: "",
  iconSize: "16px",
  titleSize: "14px",
  disableMobile: false,
  mobileShowWidth: "767px",
  mobileModalPosition: {}
};
Tooltip.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "hideTooltip",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "showTooltip",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getPosition",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "position",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Tooltip",
  "props": {
    "position": {
      "defaultValue": {
        "value": "\"RIGHT\"",
        "computed": false
      },
      "required": false
    },
    "title": {
      "defaultValue": {
        "value": "\"ToolTip\"",
        "computed": false
      },
      "required": false
    },
    "colorTitle": {
      "defaultValue": {
        "value": "\"black\"",
        "computed": false
      },
      "required": false
    },
    "iconName": {
      "defaultValue": {
        "value": "\"fa-question-circle\"",
        "computed": false
      },
      "required": false
    },
    "color": {
      "defaultValue": {
        "value": "\"#3b99fc\"",
        "computed": false
      },
      "required": false
    },
    "bubbleWidth": {
      "defaultValue": {
        "value": "\"350px\"",
        "computed": false
      },
      "required": false
    },
    "iconMargin": {
      "defaultValue": {
        "value": "\"5px\"",
        "computed": false
      },
      "required": false
    },
    "iconMarginMoblie": {
      "defaultValue": {
        "value": "\"-5px\"",
        "computed": false
      },
      "required": false
    },
    "weightTitle": {
      "defaultValue": {
        "value": "\"500\"",
        "computed": false
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "required": false
    },
    "iconSize": {
      "defaultValue": {
        "value": "\"16px\"",
        "computed": false
      },
      "required": false
    },
    "titleSize": {
      "defaultValue": {
        "value": "\"14px\"",
        "computed": false
      },
      "required": false
    },
    "disableMobile": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "mobileShowWidth": {
      "defaultValue": {
        "value": "\"767px\"",
        "computed": false
      },
      "required": false
    },
    "mobileModalPosition": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "required": false
    }
  }
};

module.exports = Tooltip;
//# sourceMappingURL=tooltip.js.map
